import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import {
    collection,
    query,
    where,
    onSnapshot,
    getDocs
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../../components_root/rendom_code";
import { Toast } from '../../components_root/ToastContext';
import { MdAddAPhoto, MdArrowBackIos, MdClose, MdDone, MdMoney, MdSave, MdSearch } from "react-icons/md";
import { Save_log_history } from "../../log_history_root/save_log_history";
import logo_default from "../../assets/logo_default.jpg";
import Loading from "../../components_root/loading.jsx";
import Loadingimg from "../../components_root/loadingimg.jsx";
import { Uploader_files } from "../../components_root/uploader_files.js";
export default function Update_staff_ledger_account({ accountguid }) {
    const [accounts_name, setAccounts_name] = useState("");
    const [description, setDescription] = useState("");
    const [mobile, setMobile] = useState();
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [slug, setSlug] = useState("");
    const [account_type, setAccount_type] = useState("");
    const [account_status, setAccount_status] = useState(false);
    const servicetablename = "accountingfinancedb";
    const [verify_note, setVerify_note] = useState("");
       const [IsLoading2, setIsLoading2] = useState(true);
    const [logoUrl, setLogoUrl] = useState("");
    const [old_file_uid, setOld_file_uid] = useState("");
    const [isLoading_banner, setIsLoading_banner] = useState(false);
    const [accountdata, setAccountdata] = useState([]);
    useEffect(() => {
        if (!accountguid) return;

        const loadStaffAccount = async () => {
            const sessiontoken = Cookies.get("sessiontoken");
            const guid = Cookies.get("guid");
            const select_company_uid = Cookies.get("select_company_uid");

            if (!sessiontoken || !guid || !select_company_uid) {
                console.error("Login/Cookies invalid");
                return;
            }

            try {
                const CollectionRef = collection(
                    db,
                    servicetablename,
                    select_company_uid,
                    "ledger_accounts"
                );

                const QueryRef = query(
                    CollectionRef,
                    where("accountguid", "==", accountguid)
                );

                const Snap = await getDocs(QueryRef);

                if (Snap.empty) {
                    console.error("Staff account not found");
                    return;
                }

                const docData = Snap.docs[0].data();

                // set main data
                setAccountdata(docData);

                // use docData directly instead of old state
                setOld_file_uid(docData.logo_uid || "null");
                setAccounts_name(docData.name || "");
                setDescription(docData.description || "");
                setAccount_type(docData.account_type || "");
                setAccount_status(docData.status ?? false);
                setLogoUrl(docData.logo_url || "");
            } catch (err) {
                console.error("Load staff account error:", err);
            }
        };

        loadStaffAccount();
    }, [accountguid]);
    const handleCreate = async () => {
        const logid = Randomcode(25);
        if (!account_type || !account_type.trim()) {
            Toastshow("Please Select role type.");
            return;
        }
        if (!description || !description.trim()) {
            Toastshow("Please enter Description.");
            return;
        }
        if (!description || !description.trim()) {
            Toastshow("Please enter Description.");
            return;
        }
        if (!verify_note || !verify_note.trim()) {
            Toastshow("Please enter a verification note.");
            return;
        }
        const dataupdates = {
            log_id: logid,
            description: description,
            name:accounts_name,
            account_type:account_type,
            status: account_status,
            // Add other necessary fields here
        };
        create_log(logid, dataupdates, accountguid, "Account", description, verify_note);
    };
    const create_log = async (logid, dataupdates, filedid, account_type, description, verify_note) => {

        const log_description = "account_type:" + account_type + ", " + description;
        const log_data = {
            logid,
            history_type: "ledger accounts",
            servicetablename: "accountingfinancedb",
            tablename: "ledger_accounts",
            filedname: "accountguid",
            filedid: filedid,
            log_description,
            log_status: false,
            verify_status: false,
            verify_note,
            //change info            
            dataupdates,
            description: description,
            account_type: account_type,
        };
        const result = await Save_log_history(log_data);
        if (result.success) {
            //  navigate(-1);
            Toastshow("Saved successfully.");

        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    };


    //change logo
    const [logo_file, setLogo_file] = useState(null);
    const logo_Upload = async () => {
        if (!logo_file) return;
        if (!old_file_uid) return;
        if (!Cookies.get("guid")) return Toastshow("Please login");
        if (!Cookies.get("select_company_uid")) return Toastshow("Please select company");

        // ⚡ Pass the uid of the company you’re editing
        const result = await Uploader_files({
            file: logo_file,
            servicetablename,
            fileuid: accountguid,
            tablename: "ledger_accounts",
            filename: "logo",
            old_file_uid,
        });

        if (result.success) {
            Toastshow("Successfully!");
            setLogo_file(null);

        } else {

            setLogo_file(null);
            Toastshow(`Error: ${result.error}`);
        }
    };
    useEffect(() => {
        if (logo_file) {
            logo_Upload();
        }
    }, [logo_file]);
     
    const [accounting_groups_raw, setaccounting_groups_raw] = useState([]);
    
    useEffect(() => {
        const masterQuery = query(
            collection(db, "accounting_groups_list_master")
        );
    
        const unsubscribeMaster = onSnapshot(masterQuery, (snapshot) => {
            const rawList = snapshot.docs.map((d) => d.data());
    
            setaccounting_groups_raw(rawList); // 👈 keep raw
            setIsLoading2(false);
        });
    
        return () => unsubscribeMaster();
    }, []);
    const normalize = (slug = "") => {
        return slug
            .replace(/^https?:\/\//i, "")   // remove http:// or https://
            .replace(/\/+$/, "")            // remove trailing slash
            .replace(/[^a-zA-Z0-9]/g, "")   // remove ALL special characters
            .toLowerCase();                 // make lowercase
    };
    return (
        <div >
            <div className="items-back ">

                <div>
                    <div className="logo-div">
                        {isLoading_banner === true ? (
                            <Loadingimg />
                        ) : (
                            <>
                                <img src={logoUrl || logo_default}
                                    alt="logo" className="brand-thumbnail" />
                                <div className="change_image flex center">
                                    {logo_file !== null ? (
                                        <Loadingimg />
                                    ) : (
                                        <label>
                                            <MdAddAPhoto className="icon white cursor" />
                                            <input
                                                type="file" accept=".jpg,.jpeg,.png"
                                                style={{ display: "none" }}
                                                onChange={async (e) => {
                                                    const selectedFile = e.target.files[0];
                                                    if (selectedFile) {
                                                        setLogo_file(selectedFile);
                                                        setLogoUrl(URL.createObjectURL(selectedFile));

                                                    }
                                                }}
                                            />
                                        </label>

                                    )}

                                </div>
                            </>
                        )}

                    </div>
                </div>
                <table>
                    <tr>
                        <td>
                            <div
                                className={
                                    ` text-h3 fcap bold ` +
                                    (accountdata[0]?.account_type === "cashier" ? "button-ui red-back" : "button-ui2")
                                }
                            >
                                {accountdata[0]?.account_type.replaceAll("_", " ")}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td><div className="text-h2 bold">Account role type</div></td>
                    </tr>

                    <tr>
                        <td>
                    <select
    value={account_type}
    onChange={(e) => setAccount_type(e.target.value)}
    className="text-h2 bold p-2"
>
    <option value="">Select account</option>

    {accounting_groups_raw.reduce((acc, item) => {
        const key = `${item.group}_${item.group_title}`;

        if (!acc[key]) {
            acc[key] = {
                label: `${item.group_title} (${item.group})`,
                items: []
            };
        }

        acc[key].items.push(item);
        return acc;
    }, {}) &&
        Object.values(
            accounting_groups_raw.reduce((acc, item) => {
                const key = `${item.group}_${item.group_title}`;

                if (!acc[key]) {
                    acc[key] = {
                        label: `${item.group_title} (${item.group})`,
                        items: []
                    };
                }

                acc[key].items.push(item);
                return acc;
            }, {})
        ).map((group) => (
            <optgroup key={group.label} label={group.label}>
                {group.items.map((item) => (
                    <option
                        key={item.groupid}
                        value={item.groupid}   // ✅ THIS IS WHAT YOU WANT
                    >
                     <div className="fcap">{item.account_type.replaceAll("_", " ")}</div>
                    </option>
                ))}
            </optgroup>
        ))}
</select>

                        </td>
                    </tr>
                    <tr>
                        <td><div className="text-h2 bold">Description</div></td>
                    </tr>
<tr>
                        <td>
                            <input
                                value={accounts_name}
                                onChange={(e) => setAccounts_name(e.target.value)}
                                maxLength={70}
                                placeholder="Enter Name"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td><textarea className="p-2" value={description} onChange={(e) => setDescription(e.target.value)} maxLength={200} placeholder="Enter description" /></td>
                    </tr>
                    <tr>
                        <td>
                            <input
                                value={verify_note}
                                onChange={(e) => setVerify_note(e.target.value)}
                                maxLength={100}
                                placeholder="Enter a verification note"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className="">
                                <table className="table-fixed">
                                    <tr>
                                        <td>
                                            <div
                                                onClick={() => setAccount_status(true)}
                                                className={`fill p-2 cursor ${account_status === true ? "button-ui green-back" : "button-ui2"}`}
                                            >
                                                <MdDone className="icon" />
                                                Activate
                                            </div>
                                        </td>

                                        <td>
                                            <div
                                                onClick={() => setAccount_status(false)}
                                                className={`fill p-2 cursor ${account_status === false ? "button-ui red-back" : "button-ui2"}`}
                                            >
                                                <MdClose className="icon" />
                                                Deactivate
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </td>
                    </tr>
                </table>
                <div className="button-ui p-2 fill text-h2 fcap  cursor" onClick={() => handleCreate()}><MdSave className="icon" />  Update </div>

            </div>
        </div>
    );
}
